import {UI} from "../../stem-core/src/ui/UIBase";
import {WidgetClose} from "../SVGElements";
import {registerStyle} from "../../stem-core/src/ui/style/Theme";
import {collapseIframe} from "../widget/misc/WidgetUtils";
import {WidgetCloseButtonStyle} from "../widget/WidgetCloseButton";
import {styleRuleInherit} from "../../stem-core/src/decorators/Style";
import {AnalyticsEventType, dispatchAnalyticsEvent} from "../../blink-sdk/utils/AnalyticsClient";


class PanelCloseButtonStyle extends WidgetCloseButtonStyle {
    @styleRuleInherit
    closeButton = {
        opacity: 1,
        cursor: "pointer",
        pointerEvents: "initial",
    };
}

@registerStyle(PanelCloseButtonStyle)
export class PanelCloseButton extends WidgetClose {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            color: this.styleSheet.themeProps.MERCHANT_FRAME_CLOSE_BUTTON_COLOR,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.closeButton);
        if (this.options.anid) {
            attr.setAttribute("data-blink-anid", this.options.anid);
        }
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => {
            dispatchAnalyticsEvent(AnalyticsEventType.ELEMENT_CLICK);
            collapseIframe();
        });
    }
}
